<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Registrar Trabajador
            <router-link :to="{ name: 'Trabajadores' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <div class="mb-3">
              <label class="mr-2">Estado:</label>
              <CSwitch
                :checked="!suspendido"
                @update:checked="toggleSuspendido()"
                class="mx-1"
                color="primary"
                variant="3d"
              />
              {{ !suspendido ? "Activo" : "Suspendido" }}
            </div>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombreTrabajador.$model"
                  :isValid="checkIfValid('nombreTrabajador')"
                  label="Nombre del trabajador:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>

            <!-- <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicación:</label>
                <v-select
                  v-model="ubicacion"
                  :options="ubicaciones"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona una ubicación"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow> -->

            <!-- Ultimos cambios, en espera del back, solo descomentar -->

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicaciones:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="multi"
                    :options="ubicaciones"
                    :multiple="true"
                    label="label"
                    :loading="isLoadingPage"
                    track-by="label"
                    placeholder="Selecciona uno o varias ubicaciones"
                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="multi && multi.length" @click="cleanMulti()">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
            </CRow>

            <CRow v-if="multi && multi.length > 0">
              <CCol sm="12" md="9" lg="9">
                <label>Ubicación principal:</label>
                <v-select
                  v-model="ubicacion_principal"
                  :options="multi"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  :disabled="multi.length === 1"
                  placeholder="Selecciona una ubicación"
                >
                  <template #open-indicator="{attributes}">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Empresa:</label>
                <v-select
                  v-model="empresa"
                  :options="empresas"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona una empresa"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Puesto:</label>
                <v-select
                  v-model="puesto"
                  :options="puestos"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un puesto"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.costo.$model"
                  :isValid="checkIfValid('costo')"
                  label="Costo:"
                  placeholder="Costo.."
                  type="number"
                  append=".00"
                  prepend="$"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="unidad"
                  :value.sync="$v.unidad.$model"
                  :isValid="checkIfValid('unidad')"
                  label="Unidad:"
                  placeholder="Unidad..."
                  invalidFeedback="Campo requerido, debe tener al menos 1 caracter y maximo 5 caracteres"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="costo_extra"
                  label="Costo extra"
                  placeholder="Costo extra.."
                  type="number"
                  append=".00"
                  prepend="$"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="unidad_extra"
                  label="Unidad extra:"
                  placeholder="Unidad extra..."
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Dispositivos:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="dispositivos"
                    :options="dispositivosList"
                    :multiple="true"
                    label="label"
                    :loading="isLoadingPage"
                    track-by="label"
                    placeholder="Selecciona uno o varias dispositivos"
                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="dispositivos && dispositivos.length" @click="()=>{dispositivos=[]}">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol class="mb-3 d-flex flex-column" sm="12" md="9" lg="9">
                <label>Foto trabajador:</label>
                <input
                  ref="imgTr"
                  @change="inputFile"
                  type="file"
                  label="Unidad extra:"
                  placeholder="Image..."
                />
              </CCol>
            </CRow>
            <img
              v-show="url"
              class="mb-2"
              width="50"
              height="50"
              :src="url"
              :alt="urlName"
            />

            <ExtraConfigInput
              title="del trabajador"
              parametro="trabajadores_atributos_extras"
              v-model="fieldsExtra"
              @config="config => (fieldsExtraConfig = config)"
              @onValid="v => (valid = v)"
            />

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="
                    () => {
                      fetching = false;
                    }
                  "
                  @onErrorFetch="
                    err => {
                      fetching = false;
                      error = err;
                      warningModal = true;
                    }
                  "
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                  >Guardado con éxito.</CAlert
                >
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Trabajadores' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addTrabajador()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal
        size="sm"
        title="Trabajador"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>

import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import "vue-select/dist/vue-select.css";

import ExtraConfigInput from "./../../customComponents/ExtraConfigInput.vue";

export default {
  name: "NuevoTrabajador",

  components: {
    Multiselect,
    vSelect,
    ExtraConfigInput
  },

  computed: {
    dispositivosList(){
      const ubicaciones = this.multi?.map(m=>m.value)??[]
      const list = this._dispositivosList?.length>0?this._dispositivosList:[]
      return list.filter(m=>ubicaciones.includes(m.ubicacion))
    },
    isValidTrabajador() {
      return !this.$v.nombreTrabajador.$invalid;
    },
    isValidUnidad() {
      return !this.$v.unidad.$invalid;
    },
    isValidCosto() {
      return !this.$v.costo.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    },
    multi(newV, oldV) {
      console.log({ newV, oldV });
      if (newV.length === 1) {
        this.ubicacion_principal = newV[0];
      }
    }
  },

  methods: {
    inputFile(e) {
      let reader = new FileReader();
      this.url = "";
      this.urlName = "";

      reader.onload = file => {
        this.url = file.target.result;
        this.urlName = e.target.files[0].name;
      };

      reader.readAsDataURL(e.target.files[0]);
      //  this.$emit('input', this.value);
    },
    toggleSuspendido() {
      this.suspendido = !this.suspendido;
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async m => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!m.media) {
          return Promise.resolve({ data: m, status: "success" });
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    async addTrabajador() {
      this.validateTrabajador();
      this.fetching = true;
      this.isLoading = true;
      await new Promise(res => {
        const iter = setInterval(() => {
          if (!this.fetching) {
            clearInterval(iter);
            res();
          }
        }, 1000);
      });
      this.isLoading = false;
      // clean numbers extra fileds

      if (!this.valid.flag) {
        const valores = this.valid.valores;
        this.error = `Son requeridos los campos: ${valores.join(", ")}`;
        this.warningModal = true;
      }
      if (this.error) {
        this.isLoading = false;
        this.successModal = false;
        return;
      }
      debugger

      this.fieldsExtraConfig.forEach(indexField => {
        if (indexField.tipo === "number") {
          this.fieldsExtra[indexField.nombre] =
            Number(this.fieldsExtra[indexField.nombre]) || 0;
        }
        if (indexField.tipo === "text") {
          this.fieldsExtra[indexField.nombre] =
            this.fieldsExtra[indexField.nombre] || "";
        }
      });

      if (this.isValidTrabajador && this.isValidUnidad && this.isValidCosto) {
        // Ultimos cambios, en espera del back, solo descomentar
        // if (!this.multi && !this.multi.length) {
        if (!this.ubicaciones) {
          this.error = "El campo ubicación es obligatorio";
          this.warningModal = true;
          return;
        }
        // Ultimos cambios, en espera del back, solo descomentar
        if (!this.empresa) {
          this.error = "El campo empresa es obligatorio";
          this.warningModal = true;
          return;
        }
        if (!this.puesto) {
          this.error = "El campo puesto es obligatorio";
          this.warningModal = true;
          return;
        }

        this.isLoading = true;

        let img = this.$refs.imgTr;
        if (img.files[0]) {
          let formData = new FormData();
          formData.append("media", img.files[0]);

          this.$store
            .dispatch("customImageHTTP", formData)
            .then(res => {
              this.addTrabajadorFull(res.data);
            })
            .catch(() => {
              //console.log(rej);
            });
        } else {
          // Ultimos cambios, en espera del back, solo descomentar

          const newUbicaciones =
            this.multi &&
            this.multi.map(ubi => {
              return ubi.value;
            });

          let agregarTrabajador = {
            schema: "trabajadores",
            payload: {
              nombre: this.nombreTrabajador,
              ubicaciones: newUbicaciones,
              empresa_id: this.empresa && this.empresa.value,
              puesto_id: this.puesto && this.puesto.value,
              costo: this.costo ? Number(this.costo) : 0,
              costo_extra: this.costo ? Number(this.costo_extra) : 0,
              unidad: this.unidad,
              unidad_extra: this.unidad_extra,
              suspendido: this.suspendido ? true : false,
              anexos: this.medias,
              dispositivos: this.dispositivos?this.dispositivos.map(m=>m.value):undefined,
              ubicacion_principal_id:
                this.ubicacion_principal && this.ubicacion_principal.value
            }
          };
          if (this.fieldsExtraConfig.length > 0) {
            agregarTrabajador.payload.extras = this.fieldsExtra;
          }

          this.$store
            .dispatch("customActualizarHTTP", agregarTrabajador)
            .then(() => {
              //
              this.currentAlertCounter = 6;
              // this.$router.push({ name: "Trabajadores" });
            })
            .catch(rej => {
              // console.log(rej);
              this.error = rej.message;
              this.warningModal = true;
            })

            .finally(() => {
              this.isLoading = false;
            });
        }
      }
    },
    fetchOptions(search, loading) {
      console.log({ search, loading });
      debugger;
      return;
    },
    addTrabajadorFull() {
      this.fieldsExtraConfig.forEach(indexField => {
        if (indexField.tipo === "number") {
          this.fieldsExtra[indexField.nombre] =
            Number(this.fieldsExtra[indexField.nombre]) || 0;
        }
        if (indexField.tipo === "text") {
          this.fieldsExtra[indexField.nombre] =
            this.fieldsExtra[indexField.nombre] || "";
        }
      });
      const newUbicaciones =
        this.multi &&
        this.multi.map(ubi => {
          return ubi.value;
        });
      // Ultimos cambios, en espera del back, solo descomentar
      let agregarTrabajador = {
        nombre: this.nombreTrabajador,
        ubicaciones: newUbicaciones,
        empresa_id: this.empresa && this.empresa.value,
        puesto_id: this.puesto && this.puesto.value,
        costo: this.costo ? Number(this.costo) : 0,
        costo_extra: this.costo ? Number(this.costo_extra) : 0,
        unidad: this.unidad,
        unidad_extra: this.unidad_extra,
        suspendido: this.suspendido ? true : false,
        anexos: this.medias,
        dispositivos: this.dispositivos?this.dispositivos.map(m=>m.value):undefined,
        ubicacion_principal_id:
          this.ubicacion_principal && this.ubicacion_principal.value
      };
      if (this.fieldsExtraConfig.length > 0) {
        agregarTrabajador.payload.extras = this.fieldsExtra;
      }

      this.isLoading = true;
      this.$store
        .dispatch("customActualizarHTTP", agregarTrabajador)
        .then(() => {
          //
          this.currentAlertCounter = 6;
          // this.$router.push({ name: "Trabajadores" });
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.isLoading = false;
        });
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateTrabajador() {
      this.$v.nombreTrabajador.$touch();
      this.$v.costo.$touch();
      this.$v.unidad.$touch();
      this.error = "";
      // this.$v.equivalencia_6oz.$touch();
    },
    updateCombos() {
      const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      this.isLoadingPage = true;
      const cat = [];

      // if (this.ubicacionRaizValue) {
      //   cat.push(ubicacionTemplateRaiz);
      // } else {
      //   cat.push(ubicacionTemplateNoRaiz);
      // }
      cat.push(ubicacionTemplateNoRaiz);
      Promise.all(cat)
        .then(([res]) => {
          this.ubicaciones = res.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
        })
        .finally(() => (this.isLoadingPage = false));
    },
    cleanMulti() {
      this.multi = [];
    }
  },

  created() {
    // const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
    //   schema: "ubicaciones",
    //   filter: {
    //     where: [
    //       {
    //         field: "id",
    //         value: this.ubicacionRaizValue,
    //         operator: "="
    //       }
    //     ]
    //   }
    // });

    const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->pertenece_id",
            value: 0,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });

    this.isLoadingPage = true;
    // Ultimos cambios, en espera del back, solo descomentar
    const cat = [
      this.$store.dispatch("customHTTP", {
        schema: "empresas"
      }),
      this.$store.dispatch("customHTTP", {
        schema: "puestos"
      }),
      this.$store.dispatch("customHTTP", {
        schema: "dispositivos",
        _filter:{
          where:[
            {
              field: 'payload->ubicacion_raiz_id',
              operator: '=',
              value: this.ubicacionRaizValue
            }
          ]
        }
      })
    ];

    // if (this.ubicacionRaizValue) {
    //   cat.push(ubicacionTemplateRaiz);
    // } else {
    //   cat.push(ubicacionTemplateNoRaiz);
    // }

    cat.push(ubicacionTemplateNoRaiz);

    // Ultimos cambios, en espera del back, solo descomentar
    Promise.all(cat)
      .then(([empresas, puestos, dispositivos, res]) => {
        this.empresas = empresas.data.map(emp => {
          return { value: emp.id, label: emp.payload.nombre };
        });
        this.puestos = puestos.data.map(pue => {
          return { value: pue.id, label: pue.payload.nombre };
        });
        this.ubicaciones = res.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this._dispositivosList = dispositivos.data.map(dispocitivo=>{
          return { value: dispocitivo.id, label: dispocitivo.payload.nombre, ubicacion: dispocitivo.payload.ubicacion_raiz_id };
        })
      })
      .finally(() => (this.isLoadingPage = false));
  },

  mixins: [validationMixin],
  validations: {
    nombreTrabajador: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },

    unidad: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(5)
    },
    costo: {
      required
    }
  },

  data() {
    return {
      date: null,
      multi: null,
      dispositivos: null,
      _dispositivosList: [],
      nombreTrabajador: "",
      ubicacion: null,
      ubicacion_principal: null,
      ubicaciones: [],
      // Ultimos cambios, en espera del back, solo descomentar
      empresa: null,
      empresas: [],
      puesto: null,
      puestos: [],
      dia: null,
      dias: [
        { value: 0, label: "Lunes" },
        { value: 1, label: "Martes" },
        { value: 2, label: "Miércoles" },
        { value: 3, label: "Jueves" },
        { value: 4, label: "Viernes" },
        { value: 5, label: "Sabado" },
        { value: 6, label: "Domingo" }
      ],
      costo: null,
      cantidad: "",
      unidad: "",
      costo_extra: null,
      unidad_extra: "",
      url: "",
      urlName: "",
      warningModal: false,
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
      suspendido: false,
      fetching: false,
      valid: { flag: true },
      medias: []
    };
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 100%;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
